import { render, staticRenderFns } from "./WalletBalance.vue?vue&type=template&id=1a88eaaa&"
import script from "./WalletBalance.vue?vue&type=script&lang=js&"
export * from "./WalletBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports